import React, { useContext, useMemo } from 'react';
import { Table } from 'reactstrap';
import { TeamContext } from '../contexts/teamContext';
import { ChallengeContext } from '../contexts/challengeContext';

export default function Rating() {
    const ctx = useContext(TeamContext);
    const challengeCtx = useContext(ChallengeContext);
    const rounds = useMemo(() => (challengeCtx.challenge.rounds
        ? challengeCtx.challenge.rounds.map((round) => round.id)
        : []), [challengeCtx]);
    const lastRound = rounds.length > 0 ? rounds[rounds.length - 1] : '';
    const lastRoundScore = (team) => team.points[lastRound] || 0;

    const byLastScore = (team1, team2) => {
        if (lastRoundScore(team1) < lastRoundScore(team2)) return 1;
        if (lastRoundScore(team1) > lastRoundScore(team2)) return -1;
        return 0;
    };

    return (
      <div>
        <h1>Рейтинг</h1>
        <Table responsive>
          <thead>
            <tr>
              <th>#</th>
              <th>Команда</th>
              <th>Состав</th>
              { rounds.map((round, roundIndex) => (
                <th key={roundIndex}>{round}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            { ctx.teams
                .filter((team) => team.challengeId === challengeCtx.challenge.id)
                .sort(byLastScore)
                .map((team, teamIdex) => (
                  <tr key={teamIdex}>
                    <td>{teamIdex + 1}</td>
                    <td>{team.teamName}</td>
                    <td>{team.members.join(', ')}</td>
                    { rounds.map((round, roundIndex) => round === lastRound
                      ? <td key={roundIndex}><b>{ team.points[round] }</b></td>
                      : <td key={roundIndex}>{ team.points[round] }</td>)
                    }
                  </tr>
                ))}
          </tbody>
        </Table>
      </div>
    );
}
